import survey from './survey'

export default {
  survey,
  title: {
    management: 'CRM',
    tag: {
      management: 'Tag Management',
      task: 'Task Management',
      add: 'Add Tag',
      edit: 'Edit Tag',
      addTask: 'Add Task',
      editTask: 'Edit Task'
    },
    microsite: {
      management: 'Microsite Management',
      add: 'Add Microsite',
      edit: 'Edit Microsite'
    },
    talentFilterGroup: 'Talent Pool Management',
    campaign: {
      management: 'Campaign Management',
      list: 'Campaign List',
      add: 'Add Campaign',
      edit: 'Edit Campaign',
      send: 'Send Campaign',
      report: 'Campaign Report',
      micrositeFormExport: 'Microsite Form Export'
    }
  },
  tab: 'CRM',
  label: {
    pv: 'PV',
    application: 'Application',
    tag: {
      tagName: 'Tag English Name',
      tagCnName: 'Tag Chinese Name',
      judgingCriteria: 'Condition',
      conditionRule: 'Condition',
      setCondition: 'Set Criteria',
      conditionNo: 'Condition {number}:',
      taskName: 'Task Name',
      taskStatus: 'Task Status',
      tagList: 'Tag List',
      taskStatusSuccess: 'Success',
      taskStatusPadding: 'Pending',
      taskStatusDoing: 'In progress',
      systemOperator: 'System'
    },
    microsite: {
      pcOrMobile: 'PC/Mobile',
      micrositeName: 'Microsite Name',
      timeRange: 'Campaign Duration',
      jobIds: 'Jobs',
      micrositeLink: 'Microsite URL',
      webEnLink: 'PC Web (English)',
      webCnLink: 'PC Web (Chinese)',
      mobileEnLink: 'Mobile Web (English)',
      mobileCnLink: 'Mobile Web (Chinese)',
      publish: 'Publish',
      visibility: 'Visibility',
      chatbot: 'Chatbot',
      share: 'WeChat Share Settings',
      shareImage: 'WeChat Share Icon',
      group: 'Group',
      cnGroupName: 'Group name (Chinese)',
      enGroupName: 'Group name (English)',
      addGroup: 'Add Microsite Group',
      editGroup: 'Edit Microsite Group'
    },
    talentFilterGroup: {
      creator: 'Creator',
      private: 'Private'
    },
    talent: {
      candidateStatus: {
        hot: 'Applied <7 days',
        active: 'Applied <30 days',
        warm: 'Visited <90 days',
        potential: 'Non registered visitor',
        cold: 'No activity <90 days'
      }
    },
    campaign: {
      name: 'Campaign Name',
      microsite: 'Microsite',
      receiptEmail: 'Receipt Email',
      date: 'Date',
      copyLink: 'Press Ctrl+C to copy the URL',
      notificationHeader: 'Send Campaign',
      shareConfigHeader: 'WeChat Share Settings',
      dateRange: 'Date Range',
      emailDetail: 'Email Detail'
    },
    campaignReport: {
      all: 'All stages',
      title: 'Campaign Report',
      sent: 'Sent',
      realSent: 'Delivered',
      micrositePV: 'Microsite Page Views',
      jobPV: 'Job Page Views',
      applied: 'Job Applications',
      screened: 'Screened Applications',
      interviewed: 'Interviews',
      hired: 'Hires',
      conversionRate: 'Conversion Rate: {rate}%',
      export: 'Export',
      newTalentCount: 'Talent Pool Applications',
      potentialCandidateCount: 'Lead/Prospect Views',
      wxDelivered: 'WeChat Delivered',
      emailDelivered: 'Email Delivered',
      wxSent: 'WeChat Sent',
      emailSent: 'Email Sent',
      onlyMicrosite: 'Microsite Only'
    },
    campaignNotification: {
      header: 'Send Campaign: {name}',
      talentGroup: 'Talent Pool',
      message: 'Message',
      messageType: 'Message Type',
      emailSubject: 'Email Subject',
      messagePreview: 'Wechat Preview',
      emailContent: 'Email Content',
      alumniSearchType: 'Recipient',
      portal: 'Campaign Portal',
      confirmSendDialogTitle: 'Confirm sending?',
      confirmSendDialogContent: 'You will send this campaign to the Talent Group below: \n{groupName}\nTotal: {totalCount} talents'
    },
    home: {
      talentPoolManagement: 'Talent Pool Management',
      campaignManagement: {
        campaign: 'Campaign Management - Campaign',
        report: 'Campaign Management - Report'
      },
      micrositeManagement: 'Microsite Management',
      tagManagement: 'Tag Management',
      surveyManagement: 'Candidate Survey Management',
      back: 'Back'
    }
  },
  menu: {
    tag: 'Tag Management',
    task: 'Task Management',
    talentFilterGroup: 'Talent Pool Management',
    micrositeManagement: 'Microsite Management',
    campaign: 'Campaign Management - Campaign',
    report: 'Campaign Management - Report'
  },
  placeholder: {
    keywords: 'Keywords',
    tag: {
      tagName: 'Please enter tag name',
      tagList: 'Please select tag',
      taskName: 'Please enter task name',
      condition: {
        relation: {
          less_salary: 'The Lowest',
          more_salary: 'The Highest',
          less_work_years: 'The Least',
          more_work_years: 'The Most',
          less_age: 'The Lowest',
          more_age: 'The Highest',
          intValue: 'Please enter number',
          stringValue: 'Support multiple keywords. Input and press \'Enter\' to add.',
          gender: 'Please select gender'
        }
      }
    },
    microsite: {
      micrositeName: 'Please enter microsite name',
      startDate: 'Please select start date',
      endDate: 'Please select end date',
      jobIds: 'Please select jobs',
      visibility: 'Please select visibility',
      shareFriendsTitle: 'Send To Chat Title',
      shareMomentsTitle: 'Share On Moments Title',
      shareDesc: 'Send To Chat Content',
      group: 'Please select group',
      groupName: 'Please input group name'
    },
    talentFilterGroup: {
      keywordSearch: 'Keyword Search'
    },
    campaign: {
      search: {
        keywords: 'Keywords',
        microsite: 'Microsite'
      },
      name: 'Please enter campaign name',
      microsite: 'Please select microsite',
      receiptEmail: 'Please enter receipt email',
      startDate: 'Start Date',
      endDate: 'End Date'
    },
    campaignReport: {
      searchCampaign: 'Search Campaign',
      searchMicrosite: 'Search Microsite',
      category: 'All stages',
      startDate: 'From',
      endDate: 'To'
    },
    campaignNotification: {
      talentGroup: 'Please select talent pool',
      message: 'Please select message',
      wechatPreview: 'Wechat preview',
      emailPreview: 'Email',
      emailSubject: 'Please input email subject',
      emailContent: 'Please input email content',
      alumniType: 'Please select the recipient'
    }
  },
  message: {
    tag: {
      tagName: 'Please enter tag name',
      conditionRule: 'Please select condition',
      conditions: 'Please input at least one criteria',
      intValue: 'Please enter number',
      keywordNotEmpty: 'Please enter keyword',
      requestError: 'Request error, please re-fresh the page and try again',
      deleteConfirm: 'Are you sure you want to delete the tag?',
      taskName: 'Please enter task name',
      tagList: 'Please select at least one tag',
      taskDeleteConfirm: 'Are you sure you want to delete the task?'
    },
    microsite: {
      micrositeName: 'Please enter microsite name',
      timeRange: 'Please select campaign duration',
      jobIds: 'Please select jobs',
      requestError: 'Request error, please re-fresh the page and try again',
      deleteConfirm: 'Are you sure you want to delete the microsite?',
      shareTip: 'You can set up the content of WeChat sharing here. The sharing icon should not be smaller than 300px x 300px; and you can use the placeholder #COMPANY_NAME# to replace the properties of company automatically inner the sharing content.',
      wrongImageType: 'Wrong file type. Only image files will be accepted',
      wrongImageSize: 'Wrong file size. Only files smaller than {size}MB will be accepted',
      uploadError: 'Upload failed, please try again later',
      hasBindCampaign: 'This Microsite has been bound to campaign!',
      deleteGroup: 'Are you sure you want to delete the microsite group?',
      addSuccess: 'Add Success',
      updateSuccess: 'Update Success',
      deleteSuccess: 'Delete Success'
    },
    talentFilterGroup: {
      deleteConfirm: 'Are you sure you want to delete the group?'
    },
    campaign: {
      nameRequired: 'Please enter campaign name',
      micrositeRequired: 'Please select microsite'
    },
    campaignNotification: {
      noMatchText: 'No matches',
      noDataText: 'No result',
      campaignRequired: 'Please select a campaign',
      talentGroupRequired: 'Please select a talent pool',
      messageRequired: 'Please select a message',
      emailContentRequired: 'Please input email content',
      notificationSent: 'Notification Sent',
      notificationSentFailed: 'Failed to send notification, please re-fresh the page and try again'
    },
    campaignReport: {
      wxDelivered: 'WeChat Delivered: {count}',
      emailDelivered: 'Email Delivered: {count}',
      wxSent: 'WeChat Sent: {count}',
      emailSent: 'Email Sent: {count}'
    }
  },
  btn: {
    addImage: 'Click to Upload',
    tag: {
      add: 'Add Tag',
      enable: 'ON',
      disable: 'OFF',
      addCondition: 'Add Criteria',
      task: 'Task',
      addTask: 'Add Task',
      back: 'Back'
    },
    microsite: {
      add: 'Add Microsite',
      addGroup: 'Add Group',
      yes: 'YES',
      no: 'NO',
      setMicrosite: 'Create / Edit Microsite',
      preview: 'Preview',
      saveAndEdit: 'Save',
      switch: {
        on: 'ON',
        off: 'OFF'
      }
    },
    campaign: {
      send: 'Send Campaign',
      copyURL: 'Copy URL',
      qrCode: 'QR Code',
      report: 'Report',
      export: 'Export',
      cancel: 'Cancel'
    }
  },
  option: {
    tag: {
      all: 'AND',
      any: 'OR',
      no: 'No Condition'
    },
    talentFilterGroup: {
      all: 'All',
      public: 'Public',
      private: 'Private',
      allCreator: 'All Groups',
      my: 'My Groups'
    },
    campaignNotification: {
      wechatAndEmail: 'WeChat and Email',
      email: 'Email',
      wechat: 'WeChat'
    },
    alumniSearchTypeOption: {
      notInTalentPool: 'Not In Talent Pool',
      InTalentPool: 'In Talent Pool',
      allInTalentPool: 'All Alumni'
    }
  },
  condition: {
    name: {
      school: 'School',
      major: 'Major',
      company: 'Company',
      salary: 'Salary',
      experience: 'Experience',
      age: 'Age',
      gender: 'Gender',
      work_years: 'Years of Working Experience',
      location: 'Home Location/Current Location',
      resume_keywords: 'Keywords from Resume'
    },
    relation: {
      equals: 'Equal To',
      contains: 'Text Contains',
      more: 'Greater Than',
      less: 'Less Than',
      between: 'Between',
      to: 'To'
    }
  },
  tooltip: {
    talentFilterGroup: {
      generatingReport: 'Generating Report...'
    }
  },
  micrositeVisibility: {
    I: 'Internal Only',
    E: 'External Only',
    IE: 'Internal & External',
    A: 'Alumni Only'
  },
  chatbot: {
    on: 'On',
    off: 'Off'
  },
  tagTypes: {
    OPENED: 'Opened',
    SHARED: 'Shared',
    'APPLIED FOR': 'Applied',
    OTHERS: 'Others',
    'SCREENED UNDER': 'Screened',
    'INTERVIEWED UNDER': 'Interviewed',
    'HIRED UNDER': 'Hired',
    SKILLS: 'Skills',
    EDUCATION: 'Education',
    WORK_EXPERIENCE: 'Work Experience',
    STABILITY: 'Stability',
    RISKS: 'Risks',
    SMART: 'Smart Tag'
  }
}
